"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "chart-box"
  }, [_c("div", {
    staticClass: "title"
  }), _vm._v(" "), _c("div", {
    staticClass: "line-chart"
  }, [_c("div", {
    style: "position: absolute;width: 100%;height: 100%;zoom:".concat(_vm.zoomrAtio, ";transform:scale(").concat(_vm.zoom, ");transform-origin:0px 0px;"),
    attrs: {
      id: _vm.id
    }
  })])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;